import React from 'react';
import './AppointmentMobileView.scss';
import { ReactComponent as PetsIcons } from '../../assets/img/profile-pic.svg';
import DeleteIcon, { ReactComponent as DeleteIconSvg } from '../../assets/img/delete-icon-v2.svg';
import CatDefaultIcon from '@/assets/img/v2/pet-cat-default-icon.svg';
import DogDefaultIcon from '@/assets/img/v2/pet-dog-default-icon.svg';
import { Appointments } from '@/features/availability/types';
import Utils from '@/utils/util';
import { ActionMenu } from '../ActionMenu';
import BoardingPetInfo from '@/features/availability/components/BoardingPetInfo';
export type HeadingProps = {
  data: Appointments;
  onCancelAppointment: (event: Appointments) => void;
  getAppointmentOption: any;
  selectedTab: number;
  actionDetails?: any;
};

export const AppointmentMobileView = ({
  data,
  onCancelAppointment,
  selectedTab,
  getAppointmentOption,
  actionDetails,
}: HeadingProps) => {
  const petData = data.pet ? [data.pet] : data.pets && data.pets.length > 0 ? data.pets : [];
  return (
    <div className={`appointment-list-mobile-div`}>
      <div className="pet-details-div">
        <div className="pet-profile">
          {petData && <BoardingPetInfo data={petData} accomodationType={data.accomodationType} />}
        </div>
        {selectedTab !== 2 && (
          <div className="action-details">
            {selectedTab == 3 ? (
              <div className="image-div">
                <img
                  src={DeleteIcon}
                  onClick={() => {
                    onCancelAppointment(data);
                  }}
                />
              </div>
            ) : (
              <ActionMenu options={getAppointmentOption} />
            )}
          </div>
        )}
      </div>
      {data.accomodationType ? (
        <div className="service-details-div">
          <div className="service-booked">SERVICE BOOKED</div>
          <div className="service-name">
            {data.accomodationType === Utils.ACCOMODATION_TYPES.BOARDING
              ? 'Boarding Service'
              : 'Daycare Service'}
          </div>
        </div>
      ) : (
        <div className="service-details-div">
          <div className="service-booked">SERVICE BOOKED</div>
          <div className="service-name">{data?.service.name}</div>
        </div>
      )}
      <div className="service-details-div">
        <div className="service-booked">STORE</div>
        <div className="service-name">{data?.businessLocation?.name}</div>
      </div>
      {!data.accomodationType || data.accomodationType == Utils.ACCOMODATION_TYPES.DAY_CARE ? (
        <div className="service-details-div">
          <div className="service-booked">
            {!data.accomodationType ? 'APPOINTMENT TIME' : 'BOOKING TIME'}
          </div>
          <div className="service-name">
            <div className="service-time">
              {Utils.formatDateStringTz(data?.startTime, data?.businessLocation.timezone)}
            </div>{' '}
            <div className="service-time second">
              {`${Utils.formatDateStringTz(
                data?.startTime,
                data?.businessLocation.timezone,
                'hh:mm A'
              )} - ${Utils.formatDateStringTz(
                data?.endTime,
                data?.businessLocation.timezone,
                'hh:mm A'
              )}`}
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="service-details-div">
            <div className="service-booked">Check-in Time</div>
            <div className="service-name">
              <div className="service-time">
                {Utils.formatDateStringTz(
                  data?.startTime,
                  data.businessLocation?.timezone,
                  "DD MMM 'yy, hh:mma"
                )}
              </div>{' '}
            </div>
          </div>
          <div className="service-details-div">
            <div className="service-booked">Check-out Time</div>
            <div className="service-name">
              <div className="service-time">
                {Utils.formatDateStringTz(
                  data?.endTime,
                  data.businessLocation?.timezone,
                  "DD MMM 'yy, hh:mma"
                )}
              </div>{' '}
            </div>
          </div>
        </>
      )}
      {selectedTab === 2 && (
        <div className="reject-note-div">
          <div className="reject-title">REJECTION NOTE</div>
          <div className="rejected-desc">{data?.rejectNote}</div>
        </div>
      )}
      <div className="menu-divider-div"></div>
    </div>
  );
};
